//https://web.dev/building-a-toast-component/
export const toaster = document.createElement('section');
toaster.setAttribute('class', 'toaster');
export const styles = document.createElement('style');
styles.innerHTML = `
.toaster {
  position: fixed;
  z-index: 99;
  inset-block-start: 0;
  inset-inline: 0;
  padding-block-start: 5vh;
  display: grid;
  justify-items: center;
  justify-content: center;
  gap: 1vh;
  pointer-events: none;
}
.red {
  border: 2px solid red;
}
.toast {
  padding-block: 0.5ch;
  padding-inline: 1ch;
  border-radius: 3px;
  font-size: 1rem;

  --_bg-lightness: 90%;
  color: black;
  background: hsl(0 0% var(--_bg-lightness) / 90%);

  --_duration: 5s;
  --_travel-distance: 0;

  will-change: transform;
  animation: fade-in 0.3s ease, fade-out 0.3s ease var(--_duration);
}
.toast.red {
  animation: fade-in 0.3s ease ease var(--_duration);
}

@keyframes fade-in { from { opacity: 0; } }
@keyframes fade-out { to { opacity: 0; } }
`;
/** Toasts notification */
export default async (text, options) => {
    if (!text) {
        return;
    }
    try {
        const message = document.createElement('output');
        message.innerText = text;
        message.setAttribute('class', (options === null || options === void 0 ? void 0 : options.persist) ? 'toast red' : 'toast');
        message.setAttribute('role', 'status');
        const { matches: motionOK } = window.matchMedia('(prefers-reduced-motion: no-preference)');
        const first = toaster.offsetHeight;
        const animate = toaster.children.length && motionOK;
        toaster.insertBefore(message, toaster.firstChild);
        if (animate) {
            const last = toaster.offsetHeight;
            const invert = -1 * (last - first);
            const transform = [
                { transform: `translateY(${invert}px)` },
                { transform: 'translateY(0)' }
            ];
            const easing = { duration: options === null || options === void 0 ? void 0 : options.duration, easing: 'ease-out' };
            toaster.animate(transform, easing);
        }
        await Promise.allSettled(message.getAnimations().map(animation => animation.finished));
        !(options === null || options === void 0 ? void 0 : options.persist) && toaster.removeChild(message);
    }
    catch (oops) {
        console.debug('[@growmark/cognito-vue]: issue displaying error message to DOM', oops);
    }
};
//# sourceMappingURL=display.toast.js.map